import { RecurringInvoiceStatus as ApiRecurringInvoiceStatus } from '@vendasta/billing';

export enum RecurringInvoiceStatus {
  INVALID = 'Invalid',
  INACTIVE = 'Inactive',
  ACTIVE = 'Active',
  ARCHIVED = 'Archived',
}

export function convertFromApiRecurringInvoiceStatus(s: ApiRecurringInvoiceStatus): RecurringInvoiceStatus {
  switch (s) {
    case ApiRecurringInvoiceStatus.RECURRING_INVOICE_STATUS_INVALID:
      return RecurringInvoiceStatus.INVALID;
    case ApiRecurringInvoiceStatus.RECURRING_INVOICE_STATUS_INACTIVE:
      return RecurringInvoiceStatus.INACTIVE;
    case ApiRecurringInvoiceStatus.RECURRING_INVOICE_STATUS_ACTIVE:
      return RecurringInvoiceStatus.ACTIVE;
    case ApiRecurringInvoiceStatus.RECURRING_INVOICE_STATUS_ARCHIVED:
      return RecurringInvoiceStatus.ARCHIVED;
    default:
      return RecurringInvoiceStatus.INVALID;
  }
}

export function convertToApiRecurringInvoiceStatus(s: RecurringInvoiceStatus): ApiRecurringInvoiceStatus {
  switch (s) {
    case RecurringInvoiceStatus.INVALID:
      return ApiRecurringInvoiceStatus.RECURRING_INVOICE_STATUS_INVALID;
    case RecurringInvoiceStatus.INACTIVE:
      return ApiRecurringInvoiceStatus.RECURRING_INVOICE_STATUS_INACTIVE;
    case RecurringInvoiceStatus.ACTIVE:
      return ApiRecurringInvoiceStatus.RECURRING_INVOICE_STATUS_ACTIVE;
    case RecurringInvoiceStatus.ARCHIVED:
      return ApiRecurringInvoiceStatus.RECURRING_INVOICE_STATUS_ARCHIVED;
    default:
      return ApiRecurringInvoiceStatus.RECURRING_INVOICE_STATUS_INVALID;
  }
}
